import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant, StyledSpan} from "@/shared/StyledComponents";
import {Button, Grid, Typography} from "@mui/material";
import {ArrowForwardIosOutlined, ArrowForwardOutlined} from "@mui/icons-material";
import {BORDER_RADIUS_LARGE, BORDER_RADIUS_MEDIUM, DIVIDER, PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {gray} from "@/shared/colors";
import {SERVICE_TYPE_KTM, ServicesDisplayMode, ServicesSectionData} from "../../types";

export function ServicesSection(props: { data: ServicesSectionData }): ReactElement {
  return <SectionContainer>
    <StyledBoxColumn style={{gap: PD_SM}}>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      {props.data.subtitle
        ? <Typography style={{opacity: 0.6}}>{props.data.subtitle}</Typography>
        : null}
    </StyledBoxColumn>
    {props.data.displayMode === ServicesDisplayMode.STANDARD
      ? <Grid container>
        {props.data.services.map((service, i) =>
          <Grid key={i} xs={12} sm={6} md={4} style={{display: "flex", padding: PD_MD}}>
            <div style={{
              padding: PD_MD,
              display: "flex",
              flexDirection: "column",
              width: "100%",
              borderRadius: BORDER_RADIUS_LARGE,
              border: DIVIDER,
              overflow: "hidden",
            }}>
              <img
                style={{
                  width: "100%",
                  borderRadius: BORDER_RADIUS_MEDIUM,
                  border: DIVIDER,
                  aspectRatio: 16 / 9,
                  background: gray,
                  objectFit: "cover"
                }}
                src={service.imageUrl || SERVICE_TYPE_KTM.findMetadata(service.type)?.imageUrl}
              />
              <StyledBoxColumn style={{
                flex: 1,
                padding: PD_LG,
                gap: PD_MD,
              }}>
                <StyledBoxColumn style={{gap: PD_SM}}>
                  <Typography variant="h6" style={{fontWeight: "bold"}}>
                    {service.title}
                  </Typography>
                  {service.description
                    ? <Typography style={{opacity: 0.65, lineHeight: 1.7}}>
                      {service.description}
                    </Typography>
                    : null}
                </StyledBoxColumn>
                {service.link?.text
                  ? <Button
                    href={service.link.url}
                    variant="text"
                    endIcon={<ArrowForwardOutlined/>}
                    style={{alignSelf: "flex-start", marginLeft: -PD_LG}}>
                    {service.link.text}
                  </Button>
                  : null}
              </StyledBoxColumn>
            </div>
          </Grid>
        )}
      </Grid>
      : null}
    {props.data.displayMode === ServicesDisplayMode.COMPACT
      ? <Grid container>
        {props.data.services.map(service => <Grid xs={12} md={6} style={{padding: PD_MD}}>
            <Button
              href={service.link.url}
              style={{border: DIVIDER, padding: PD_MD, borderRadius: BORDER_RADIUS_LARGE, height: 120, width: "100%"}}>
              <StyledBoxRow style={{width: "100%", alignItems: "center", gap: PD_LG}}>
                <img
                  style={{
                    height: 88,
                    borderRadius: BORDER_RADIUS_MEDIUM,
                    border: DIVIDER,
                    aspectRatio: 16 / 9,
                    background: gray,
                    objectFit: "cover"
                  }}
                  src={service.imageUrl || SERVICE_TYPE_KTM.findMetadata(service.type)?.imageUrl}
                />
                <StyledHeadingVariant default_={5} max={6}>{service.title}</StyledHeadingVariant>
                <StyledSpan/>
                <ArrowForwardIosOutlined/>
              </StyledBoxRow>
            </Button>
          </Grid>
        )}
      </Grid>
      : null}
  </SectionContainer>;
}
